export const NAV = {
  headerLogo: "hupla-header-logo",
  linkBrands: "nav-link-brands",
  linkAbout: "nav-link-about",
  linkB2B: "nav-link-b2b",
  linkContact: "nav-link-contact",
  ctaInquiry: "nav-cta-inquiry",
  mobileMenuBtn: "mobile-menu-toggle",
};

export const HERO = {
  root: "hero-section",
  ctaBrands: "hero-cta-brands",
  ctaB2B: "hero-cta-b2b",
};

export const BRANDS = {
  root: "brands-section",
  card: (slug) => `brand-card-${slug}`,
  page: (slug) => `brand-page-${slug}`,
  backHome: "brand-page-back-home",
  ctaInquiry: "brand-page-cta-inquiry",
  deckImage: (slug, i) => `brand-page-${slug}-deck-${i}`,
};

export const B2B = {
  root: "b2b-section",
  form: "b2b-form",
  fullName: "b2b-input-full-name",
  company: "b2b-input-company",
  email: "b2b-input-email",
  phone: "b2b-input-phone",
  country: "b2b-input-country",
  brand: "b2b-input-brand",
  inquiryType: "b2b-input-inquiry-type",
  message: "b2b-input-message",
  submit: "b2b-submit-button",
  success: "b2b-success-message",
  error: "b2b-error-message",
  portfolioPromo: "portfolio-promo",
  portfolioDownload: "portfolio-download-btn",
};

export const CONTACT = {
  root: "contact-section",
};

export const FOOTER = {
  root: "footer",
  almedaLogo: "footer-almeda-logo",
};
